var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShoppingFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#fff",
      fillOpacity: 1
    },
    d: "M16.898 6A4.994 4.994 0 0 0 12 2a4.994 4.994 0 0 0-4.898 4H4v14c0 1.102.898 2 2 2h12c1.102 0 2-.898 2-2V6zM12 3c1.86 0 3.43 1.27 3.871 3H8.13C8.57 4.27 10.14 3 12 3zm0 11c-3.309 0-6-2.691-6-6h2c0 2.21 1.79 4 4 4s4-1.79 4-4h2c0 3.309-2.691 6-6 6zm0 0"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingFilled);
export default __webpack_public_path__ + "static/media/shopping_filled.cfa950b7a44d3f65173f2c6fea774ae5.svg";
export { ForwardRef as ReactComponent };